import { cn } from "@/lib/utils";

interface GiftPandaIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

export const GiftPandaIcon = ({ className, ...props }: GiftPandaIconProps = {}) => {
  return (
    <svg
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Panda"
      className={cn("panda h-3 w-3", className)}
      {...props}
    >
      {/* Black outermost layer */}
      <path
        d="M0 4.7V4.6C0.05 2.2 2.2 0 4.6 0H15.4C17.8 0 20 2.2 20 4.7V15.3C20 17.7 17.8 19.9 15.4 19.9H4.6C2.2 19.9 0 17.7 0 15.3V4.7Z"
        fill="black"
      />
      {/* Blue outer layer */}
      <path
        d="M0.501732 4.85953V4.73292C0.566498 2.36933 2.43902 0.5 4.70873 0.5H14.9118C17.2219 0.5 19.1205 2.43643 19.1205 4.85953V15.3894C19.1205 17.8124 17.2219 19.7488 14.9118 19.7488H4.68624C2.3901 19.7488 0.501732 17.8233 0.501732 15.4126V4.85953Z"
        fill="#5EA6FF"
      />
      {/* Black middle layer */}
      <path
        d="M1.5 5.2V5.1C1.55 3.1 3.1 1.5 5.1 1.5H14.5C16.5 1.5 18.1 3.1 18.1 5.2V15.1C18.1 17.1 16.5 18.7 14.5 18.7H5.1C3.1 18.7 1.5 17.1 1.5 15.1V5.2Z"
        fill="black"
      />
      {/* White background layer */}
      <path
        d="M2.5 5.5V5.4C2.55 3.8 3.8 2.5 5.4 2.5H14.2C15.8 2.5 17.1 3.8 17.1 5.5V14.8C17.1 16.4 15.8 17.7 14.2 17.7H5.4C3.8 17.7 2.5 16.4 2.5 14.8V5.5Z"
        fill="white"
      />
      {/* Panda ears */}
      <path
        d="M7.65788 11.1353C8.61839 9.41842 8.34363 7.39886 7.04414 6.62462C5.74465 5.85032 3.9126 6.61448 2.95209 8.33141C1.99158 10.0483 2.26633 12.0679 3.56582 12.8421C4.86531 13.6164 6.69736 12.8523 7.65788 11.1353Z"
        fill="#000"
      />
      <path
        d="M6.62818 9.58359C7.193 9.58359 7.6509 9.11105 7.6509 8.52812C7.6509 7.94519 7.193 7.47266 6.62818 7.47266C6.06336 7.47266 5.60547 7.94519 5.60547 8.52812C5.60547 9.11105 6.06336 9.58359 6.62818 9.58359Z"
        fill="white"
      />
      <path
        d="M16.1067 12.8578C17.4061 12.0835 17.6809 10.064 16.7204 8.34706C15.7599 6.63013 13.9278 5.86597 12.6283 6.64021C11.3288 7.41451 11.0541 9.43401 12.0146 11.1509C12.9751 12.8679 14.8072 13.6321 16.1067 12.8578Z"
        fill="#000"
      />
      <path
        d="M13.0422 9.59921C13.6071 9.59921 14.065 9.12668 14.065 8.54375C14.065 7.96082 13.6071 7.48828 13.0422 7.48828C12.4774 7.48828 12.0195 7.96082 12.0195 8.54375C12.0195 9.12668 12.4774 9.59921 13.0422 9.59921Z"
        fill="white"
      />
      {/* Panda nose/mouth */}
      <path
        d="M9.84007 14.0584C9.84007 14.0584 9.10979 14.028 8.84853 14.2209C8.58722 14.4138 8.60449 14.712 8.60449 14.712C8.60449 14.712 8.5699 15.0174 8.6564 15.2157C8.74295 15.4139 9.24997 15.3799 9.49918 15.8211C9.49918 15.8211 9.72761 15.9015 9.84007 15.8782"
        fill="#000"
      />
      <path
        d="M9.83203 14.0584C9.83203 14.0584 10.5624 14.028 10.8237 14.2209C11.085 14.4137 11.0677 14.712 11.0677 14.712C11.0677 14.712 11.1023 15.0174 11.0158 15.2156C10.9293 15.4139 10.4222 15.38 10.173 15.8211C10.173 15.8211 9.94454 15.9015 9.83203 15.8782"
        fill="#000"
      />
    </svg>
  );
};
